import "../../components/css/News.css";
import PageTitle from "../../components/pagetitle/PageTitle";
import gambar from "../../Images/News/UDINUSSemarangTuanRumah.WebP";

function News3() {
  return (
    <>
      <PageTitle motherMenu="Media Coverage" menuback="Previous Page" backbtn="/PageNewsList" activeMenu="" />
      <div className="mt-5">
        <section className="feature section pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 ml-auto justify-content-center">
                {/* <!-- About Mockup --> */}

                {/* <div className="image-content" data-aos="fade-right"> */}
                <img className="img-fluid" src={gambar} alt="" />
                {/* </div> */}
              </div>
              <div className="col-lg-6 mr-auto align-self-center">
                <div className="feature-content">
                  {/* <!-- About Title --> */}

                  <h2>
                    <b>
                      Udinus Invited to Host YNSF and YISF, Support Young
                      Inventors from Various Countries
                    </b>
                  </h2>

                  {/* <!-- About Description --> */}

                  <p className="desc">
                    - Dian Nuswantoro University (Udinus) Semarang was asked to
                    host the Youth National Science Fair (YNSF) and Youth
                    International Science Fair (YISF).The annual event has been
                    going on since Monday (14/3/2022) and will end on Thursday
                    (17/3/2022) in the Hall of Building E, 3rd Floor of
                    Udinus.This event was attended by 502 teams from 22
                    countries in the world, ranging from elementary school (SD),
                    junior high school (SMP), high school (SMA), vocational high
                    school (SMK) and equivalent, to college.
                    <br />
                    <br />
                    Nursery of students since elementary school to engage in
                    scientific activities aims to familiarize children with
                    research or research.YNSF is a national-level project
                    science competition attended by 50 teams from all over
                    Indonesia.While YISF is a competition attended by 490 teams
                    from various countries in the world.Unlike the previous
                    year, this time the prestigious event is carried out in a
                    mix that will be held simultaneously throughout the
                    world.For offline activities, Udinus has the honor to
                    host.The activity was opened with an Opening Ceremony marked
                    by a gong blow and officially opened by Vice Rector I for
                    Academic Affairs Prof. Dr. Supriadi Rustad M.Si.
                    <br />
                    <br />
                    In his opening speech, Vice Rector I for Academic Affairs
                    Udinus Prof. Dr. Supriadi Rustad, M.S., welcomed the
                    participants of YNSF and YISF events.Udinus has prepared the
                    best possible infrastructure and facilities so that the
                    event which was attended by hundreds of participants from
                    various countries could run smoothly. He revealed that the
                    innovation produced by the participants became one of the
                    keys to a better future.
                    <br />
                    <br />
                    "We hope that the young generation of the Indonesian nation
                    will not stop innovating. With this event, they are
                    increasingly encouraged and continue to be motivated to
                    create something that is beneficial to the wider community,"
                    he explained.In this national and international scale event,
                    Udinus has prepared a Live Judging session, later dozens of
                    Udinus lecturers will be involved as judges. Furthermore,
                    participants will gain new insights in the inventors Talk
                    and Webinar sessions and will be closed with an Awarding
                    Ceremony.Meanwhile, the President of the Indonesia Youth
                    Science Association (IYSA), Deny Irawan, M.Pd., thanked
                    Udinus
                    <br />
                    <br />
                    In his welcome speech in front of offline and online
                    participants, he welcomed participants from various
                    countries who participated in the YNSF and YISF events."We
                    hope this event can be a forum for young innovations from
                    various countries, who develop their innovations in the
                    field of science," he hoped.As the host of an international
                    event, Udinus has prepared strict health protocols. Various
                    means to prevent the spread of the corona virus have also
                    been carefully prepared.
                    <br />
                    <br />
                    He also hopes that in the future this scientific competition
                    can provide space for the results obtained and can
                    collaborate with outside parties to mass produce the
                    findings of the students.Udinus also alerted a Liaison
                    Officer (LO) consisting of Udinus students to guide the
                    participants in participating in the activity.Various
                    performances from Udinus students were also displayed neatly
                    to entertain the participants. The slick performance was
                    presented by the Student Choir (PSM) Gita Dian Nuswa and
                    Dance From Udinus (DFU).One of the participants from SMA N 5
                    South Bengkulu, Tri Bintang Pratitis, said that through this
                    event he was motivated to create new innovations and achieve
                    the best achievements.
                    <br />
                    <br />
                    His team of five people will present innovations in the form
                    of special ingredient soaps. He admitted that he was happy
                    with the facilities provided by Udinus, as well as the good
                    service."For us, this event is an opportunity to seek
                    experience and relationships with fellow inventors. With
                    activities that are packaged in a hybrid manner, we think
                    the activities at Udinus can run smoothly," he concluded.
                    <br />
                    <br />
                    The participants brought prototypes and research results to
                    be presented and gave space to young researchers to present
                    their work.Head of Udinus Student Affairs Bureau, Dr. Rindra
                    Yusianto S.Kom., M.T., said that champions at the
                    international level at the high school, vocational and
                    equivalent levels have the opportunity to get scholarships
                    from Udinus in all study programs at Udinus."We provide 100%
                    scholarships for gold medals, 75% for silver medals, and 50%
                    for bronze medals for Institutional Development Endowments,"
                    he added.This is the umpteenth international event in
                    Udinus, but the first time for IYSA.
                    <br />
                  </p>
                  <p>
                    Source :{" "}
                    <a
                      href="https://jateng.tribunnews.com/2022/03/17/udinus-didaulat-jadi-tuan-rumah-ynsf-dan-yisf-dukung-inventor-muda-dari-berbagai-negara?page=2."
                      target="_blank"
                      rel="noreferrer"
                    >
                      click here
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default News3;
